module.exports = __webpack_public_path__ + "img/ZKO.65191c6e.png";